import { call, put, takeLatest } from "redux-saga/effects";
import { assignPlatformActions } from "./platformAssignSlice";
import { ApiResponse, RemovePayload } from "models";
import assignPlatformApi from "api/assignPlatform";
import { BrandSubmitForm } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  AssignPlatformPayload,
  Payload,
  BrandPayload,
  StorePayload,
  AssignPlatformSubmitForm,
} from "models/assignPlatform";

function* getAllAssignedAggregatorPlatforms(
  action: PayloadAction<AssignPlatformPayload>
) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.getAllAssignedAggregatorPlatforms,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(
        assignPlatformActions.getAllAssignedAggregatorPlatformsSuccess(data)
      );
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(
      assignPlatformActions.getAllAssignedAggregatorPlatformsFailed(errorData)
    );
  }
}
function* getCustomersList(action: PayloadAction<Payload>) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.getCustomersList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(assignPlatformActions.getCustomersListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(assignPlatformActions.getCustomersListFailed(errorData));
  }
}

function* getBrandsList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.getBrandsList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(assignPlatformActions.getBrandsListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.success(errorData?.message || "Something went wrong");
    yield put(assignPlatformActions.getBrandsListFailed(errorData));
  }
}
function* getStoresList(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.getStoresList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(assignPlatformActions.getStoresListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(assignPlatformActions.getStoresListFailed(errorData));
  }
}
function* getPlatformsList(action: PayloadAction<Payload>) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.getPlatformsList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(assignPlatformActions.getPlatformsListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    yield put(assignPlatformActions.getPlatformsListFailed(errorData));
  }
}

function* addAssignAggregatorPlatform(
  action: PayloadAction<AssignPlatformSubmitForm>
) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.addAssignAggregatorPlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(assignPlatformActions.addAssignAggregatorPlatformSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(
      assignPlatformActions.addAssignAggregatorPlatformFailed(errorData)
    );
  }
}

function* updateAssignAggregatorPlatform(
  action: PayloadAction<AssignPlatformSubmitForm>
) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.updateAssignAggregatorPlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(
        assignPlatformActions.updateAssignAggregatorPlatformSuccess(data)
      );
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(
      assignPlatformActions.updateAssignAggregatorPlatformFailed(errorData)
    );
  }
}

function* deleteAssignAggregatorPlatform(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      assignPlatformApi.deleteAssignAggregatorPlatform,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(
        assignPlatformActions.deleteAssignAggregatorPlatformSuccess(data)
      );
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(
      assignPlatformActions.deleteAssignAggregatorPlatformFailed(errorData)
    );
  }
}

export default function* assignPlatformSaga() {
  yield takeLatest(
    assignPlatformActions.getAllAssignedAggregatorPlatforms.type,
    getAllAssignedAggregatorPlatforms
  );
  yield takeLatest(
    assignPlatformActions.getCustomersList.type,
    getCustomersList
  );
  yield takeLatest(assignPlatformActions.getBrandsList.type, getBrandsList);
  yield takeLatest(assignPlatformActions.getStoresList.type, getStoresList);
  yield takeLatest(
    assignPlatformActions.getPlatformsList.type,
    getPlatformsList
  );

  yield takeLatest(
    assignPlatformActions.addAssignAggregatorPlatform.type,
    addAssignAggregatorPlatform
  );
  yield takeLatest(
    assignPlatformActions.updateAssignAggregatorPlatform.type,
    updateAssignAggregatorPlatform
  );
  yield takeLatest(
    assignPlatformActions.deleteAssignAggregatorPlatform.type,
    deleteAssignAggregatorPlatform
  );
}
